import { Task } from '@myapp/contract'
import { useScheduleTask } from '../../../entities/task'
import { CalendarPlanningOverlay, timedPlannedStartOrNull } from '../../calendar-planning-overlay'
import { DeadlineWarning } from './DeadlineWarning'

interface Props {
  show: boolean
  onClose: () => void
  onSuccess: () => void
  task: Task
  technicianId: number
}

export function WorkerTaskPlanOverlay({ show, onClose, onSuccess, task, technicianId }: Props) {
  const scheduleTask = useScheduleTask(task.id)

  const initialSelectedDate = timedPlannedStartOrNull(task.schedule?.plannedWorkStartsAt)

  return (
    <CalendarPlanningOverlay
      show={show}
      onClose={onClose}
      technicianId={technicianId}
      initialSelectedDate={initialSelectedDate}
      initialWorkDuration={task.schedule?.plannedWorkMinutes || 60}
      initialTravelDuration={task.schedule?.plannedTravelMinutes || 30}
      initialDepartureDuration={task.schedule?.plannedDepartureMinutes || 30}
      filterExistingTasks={(tasks) => tasks.filter((t) => t.id !== task.id)}
      headerTitle="Im Kalender planen"
      saveButtonColor="#124093"
      draftTitle={task.title}
      hintText="Tippe auf eine Uhrzeit im Kalender, um den Termin zu setzen"
      onSave={async (payload) => {
        await scheduleTask.mutateAsync(payload)
        onSuccess()
      }}
      isPending={scheduleTask.isPending}
      bottomExtra={(state) => (
        <DeadlineWarning selectedDate={state.selectedDate} deadline={task.deadline ?? null} />
      )}
    />
  )
}
